package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.devices.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.ClosingTypeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.dom.Text


@Composable
fun ClosingTypeConfigContent(
    closingType: String,
    updateData: (String, dynamic) -> Unit,
    isActive: Boolean
)
{

    Column() {

        MediumContentTitle(
            title = Strings.current().degree,
            marginBottom = Dimen.mediumPadding,
        )

        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.normalPadding),
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = ClosingTypeEnum.entries,
            label = Strings.current().inTheHouse,
            selectedItem = ClosingTypeEnum.entries.find {
                it.value == closingType
            },
            displayText = { item ->
                if (item is ClosingTypeEnum) item.title else ""
            },
            onOptionClick = {
                if (it is ClosingTypeEnum){
                    updateData(ApiUtils.Field.closingType, it.value)
                }
            }
        )


        CheckboxComponent(
            modifier = Modifier
                .margin(top = Dimen.normalPadding)
                .height(Dimen.outlineBoxInnerHeight),
            title = Strings.current().activateEmployeeCompletion,
            onChecked = {
                updateData(ApiUtils.Field.isEmployeeClosingActive,true)
            },
            onUnChecked = {
                updateData(ApiUtils.Field.isEmployeeClosingActive,false)
            },
            checkStatus = isActive
        )


    }
}